// reducers/websiteSettingsReducer.js
import {
  GET_HOME_PAGE_SETTING_REQUEST,
  GET_HOME_PAGE_SETTING_SUCCESS,
  GET_HOME_PAGE_SETTING_FAILED,
} from "../actions/websiteSettingActions";

const initialState = {
  loading: false,
  homePageSetting: null,
  error: "",
};

const websiteSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_PAGE_SETTING_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_HOME_PAGE_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        homePageSetting: action.payload,
        error: "",
      };

    case GET_HOME_PAGE_SETTING_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload || "Error fetching homepage settings",
      };

    default:
      return state;
  }
};

export default websiteSettingsReducer;
